import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { validateEnv } from './utils/env.util';
import { installGlobalErrorReporting } from './services/logs/logs.service';
import './theme/index.scss';

// Summary: Injects a <link rel="preconnect"> for the backend origin before React mounts so the very first XHR (login or auth/me) skips the...
// Details: docs/function-library/web/contexts-pages.md#index
const warmBackendConnection = (): void => {
    try {
        const { VITE_BACKEND_LOCATION } = validateEnv();
        const origin = new URL(VITE_BACKEND_LOCATION).origin;
        if (typeof document === 'undefined' || document.head.querySelector(`link[rel="preconnect"][href="${origin}"]`)) {
            return;
        }
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = origin;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
    } catch {
        // Preconnect is a non-essential perf hint. Never block app boot on it.
    }
};

warmBackendConnection();
installGlobalErrorReporting();

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container); 
root.render(
    <StrictMode>
        <App />
    </StrictMode>
);
